module.exports = __webpack_public_path__ + "static/img/djx.34709cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/djx.png
// module id = kWdB
// module chunks = 26